import ContractType from './ContractType'

class FranceContractType extends ContractType {
  static urlRoot() {
    return '/contracts/france/contract_types'
  }
}

export default FranceContractType
